import React, {useEffect, useState} from "react";

import {UserOutlined} from "@ant-design/icons";
import {Comment, Divider, Spin, Timeline} from "antd";

import {ModalWindow} from "./ModalWindow";
import api from "../../../api";
import {properties, ROP_MIN_LABEL} from "../../../properties";

export function HistoryModal({isModalVisible, onOk, onCancel, _id, project_id, modalProps, material, onCountLoaded}) {
	const [history, setHistory] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (isModalVisible) {
			setLoading(true);
			api.get(`/projects/${project_id}/materials/${_id}/history?material=${material}`)
				.then(json => {
					setHistory(json.data);
					onCountLoaded?.(json.data.length);
				})
				.finally(() => setLoading(false));
		}
	}, [isModalVisible]);

	const beautifyDate = date => new Date(date).toLocaleString();

	const fieldMapping = field => {
		switch (field) {
			case "price":
				return "Price per Unit ($)";
			case "lt_days":
				return "Lead Time (days)";
			case "demand":
				return "Annual Demand";
			case "appr_max":
				return "Approved Max";
			case "appr_min":
				return `Approved ${ROP_MIN_LABEL}`;
			case "proposed_min":
				return `Proposed ${ROP_MIN_LABEL}`;
			case "proposed_max":
				return "Proposed MAX";
			case "is_reviewed":
				return "Review Status";
			case "review_expiry_date":
				return "Review Expiry Date";
			case "review_notes":
				return "Review Notes";
			case "reviewed_by":
				return "Reviewed By";
			default:
				return field;
		}
	};

	const fixApprovedValues = (key, value) => {
		if (key === "approved") {
			return value ? "Approved" : "Not Approved";
		}
		if (key === "is_reviewed") {
			return value ? "Reviewed" : "Not Reviewed";
		}
		if (key === "review_expiry_date" && value) {
			return String(value).split("T")[0];
		}
		return value;
	};

	const actionMapper = action => {
		switch (action) {
			case "ITEM_UPDATE":
				return "Material Info Update";
			case "START_WORKFLOW":
				return "Workflow Initialization";
			case "MARK_REVIEWED":
				return "Material Marked as Reviewed";
			case "RESET_REVIEW":
				return "Review Reset";
			case "REVIEW_EXPIRED":
				return "Review Expired";
			default:
				return action;
		}
	};

	const beautifyChanged = changed =>
		changed.map(change => (
			<p>
				{fieldMapping(change.key)}: From {fixApprovedValues(change.key, change.old)} -> To{" "}
				{fixApprovedValues(change.key, change.new)}
			</p>
		));

	const createTimeline = () =>
		history.map(action => (
			<Timeline.Item label={beautifyDate(action.date)} color={properties.kbrColors.pantone301Blue}>
				<Comment
					author={action.user}
					avatar={<UserOutlined style={{fontSize: 24}} />}
					content={
						<div>
							<div style={{color: "blue", fontWeight: "bold"}}>{actionMapper(action.action)}</div>
							{action.comment}
							<Divider
								style={{backgroundColor: properties.kbrColors.vividCeruleanBlue, margin: "10px 0"}}
							/>
							Change:
							{beautifyChanged(action.changed)}
						</div>
					}
				/>
			</Timeline.Item>
		));

	const props = {
		...modalProps,
		width: "90vw",
		cancelButtonProps: {style: {display: "none"}},
	};

	return (
		<ModalWindow
			modalProps={props}
			isModalVisible={isModalVisible}
			title={"History of changes"}
			onCancel={onCancel}
			onOk={onOk}>
			<Spin spinning={loading}>
				<Timeline style={{marginLeft: "-50vw"}} mode="left" reverse={false}>
					{createTimeline()}
				</Timeline>
			</Spin>
		</ModalWindow>
	);
}
